import {PureComponent} from 'react'
import PropTypes from 'prop-types'

import StepIndicator from './StepIndicator.jsx'

import './StepsIndicatorContainer.scss'
import {CREATE_FREELANCE_STEPS} from "../../../../shared/containers/Freelance/setNextStep.js"

export default class StepsIndicatorContainer extends PureComponent {
  static propTypes = {
    currentStep: PropTypes.number,
    steps: PropTypes.array,
  }

  static defaultProps = {
    currentStep: null,
    steps: [],
  }
  stepIndicators = () => {
    const {currentStep} = this.props
    return  [
      {stepNumber:1, label: 'Contact', duration: '30 s', isActive: !currentStep || currentStep === 0, isDone: currentStep && currentStep > 0},
      {stepNumber:2, label: 'Planifier une visio', duration: '30 s', isActive: currentStep === 1, isDone: currentStep && currentStep > 1 },
      {stepNumber:3, label: 'Validation', duration: '5 min', isActive: currentStep >= 2 , isDone: currentStep && currentStep === CREATE_FREELANCE_STEPS.length},
    ]
  }

  render() {
    const { ...props} = this.props

    return <div className="steps-indicator-container">
      <div className="steps-indicator d-flex align-items-center justify-content-center py-3">
        {this.stepIndicators().map((step, index) => (
          <StepIndicator
            currentStep={props.currentStep}
            duration={step.duration}
            isActive={step.isActive || false}
            isDone={step.isDone || false}
            key={`step-indicator-${index}`}
            label={step.label}
            stepNumber={step.stepNumber}
          />
        ))}</div>
    </div>
  }
}
